/**
 * @author        nico@zumper.com (Nico Rattazzi)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   MessagingModal reducers
 */

import type {
  MessageModalData,
  MessageModalDataEmpty,
  MessageModalDataNonEmpty,
} from '@zcode/state-type'
import { handleActions } from 'redux-actions'
import { RECEIVE_DATA, RECEIVE_ENTITY } from '../../constants/messageModal'
import type { ActionTypes } from '../../types'

export const messagingModalReducer = handleActions<MessageModalData, ActionTypes>(
  {
    [RECEIVE_DATA]: (state, action) => {
      const {
        payload: { isMobile, ...payload },
      } = action
      if (payload) {
        return payload.analyticChannel
          ? ({
              ...state,
              equalCTAIntent: undefined,
              hasInstantTourAvailability: undefined,
              ...payload,
            } satisfies MessageModalDataNonEmpty)
          : ({
              ...state,
              analyticChannel: undefined,
              entity: undefined,
              equalCTAIntent: undefined,
              hasInstantTourAvailability: undefined,
              isQuestionModal: undefined,
              origin: undefined,
              ...payload,
            } satisfies MessageModalDataEmpty)
      }
      return state
    },
    [RECEIVE_ENTITY]: (state, action) => {
      if (!state.analyticChannel) {
        return state
      }
      return { ...state, entity: action.payload }
    },
  },
  {
    analyticChannel: '',
    ctaName: undefined,
    entity: null,
    equalCTAIntent: '',
    hasInstantTourAvailability: undefined,
    isFilterAd: false,
    isQuestionModal: false,
    onlyShowFloorplanGroup: false,
    origin: undefined,
    selectedFloorplan: undefined,
    selectedUnit: null,
    showAgentInfo: false,
    showing: false, // boolean
    similarListings: [],
    viewingId: undefined,
    viewingTime: undefined,
  }
)
